import React from "react";
import PropTypes from "prop-types";
import NumberInput from "../../common/NumberInput";
import Grid from "../../common/Grid";

const Jaarbedragen = (props) => {
    const { model, aantalJaren, showAsTotalen, errors, disabled, showGreenRed, validationMessageType } = props;

    let jaarbedragInputArray = [];
    for (let jaar = 1; jaar <= aantalJaren; jaar++) {
        let value = showAsTotalen && model["jaar" + jaar] ? model["jaar" + jaar].toFixed(2) : model["jaar" + jaar];
        const isDisabled = disabled || showAsTotalen;
        jaarbedragInputArray.push(
            <NumberInput
                key={model.id + "jaarBedrag" + jaar}
                name={"jaar" + jaar}
                label={(showAsTotalen ? "Totaal " : "") + "jaar " + jaar}
                value={value}
                maxLength={100}
                size={3}
                isValuta
                disabled={isDisabled}
                validationMessage={errors ? errors["jaar" + jaar] : ''}
                validationMessageType={validationMessageType}
            />
        );
    }
    jaarbedragInputArray.push(
        <NumberInput
            key={model.id + "Totaal"}
            name={"Totaal"}
            label={"Totaal"}
            value={model["totaal"] ? model["totaal"].toFixed(2) : model["totaal"]}
            maxLength={100}
            size={3}
            isValuta
            disabled
            floatRight
            accentuateBorder
            showGreenRed={showGreenRed}
        />
    );

    return (
        <div>
            <Grid gridItems={jaarbedragInputArray} columnCount={4} />
        </div>
    );
};

Jaarbedragen.propTypes = {
    model: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    aantalJaren: PropTypes.number,
    showAsTotalen: PropTypes.bool,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    showGreenRed: PropTypes.bool,
    validationMessageType: PropTypes.string
};

Jaarbedragen.defaultProps = {
    aantalJaren: 10,
    showAsTotalen: false,
    showGreenRed: false
};

export default Jaarbedragen;